import axios from "axios";

export class MaintenanceScheduleService {
    /**
     * Función que hace petición al back para obtener datos para la
     * pantalla de mantenimiento de horarios, obtiene el horario de
     * operación y el horario de formalización.
     * @returns {Promise<unknown>}
     */
    getSchedule() {
        return axios.get('/appapv/getSchedule.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una petición al back para obtener datos
     * para la pantalla de mantenimiento de horarios, obtiene
     * el horario de los campos del tablero de control.
     * @returns {Promise<unknown>}
     */
    getControlPanelSchedule() {
        return axios.get('/appapv/getControlPanelSchedule.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una petición al back para obtener los horarios de las instituciones
     * @returns {Promise<unknown>}
     */
    getInstitutionsSchedule() {
        return axios.get('/appapv/getInstitutionsSchedule.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace la inserción de un horario nuevo para
     * una institución
     * @param objectInstitutionSchedule Horario nuevo que se
     *          va a registrar.
     * @returns {Promise<unknown>}
     */
    updateInstitutionSchedule(objectInstitutionSchedule) {
        return axios.post('/appapv/updateInstitutionSchedule.action', {}, {
            params: {
                bandera: objectInstitutionSchedule.activo,
                idInstitucion: objectInstitutionSchedule.idInstitucion,
                horaFinal: objectInstitutionSchedule.horaFinalStr,
            }
        }).then(res => {
            this.getInstitutionsSchedule();
            return res.data;
        });
    }

    /**
     * Función que realiza el guardado de todos los horarios modificados
     * en la pantalla de mantenimiento de horarios, pestaña sistema
     * @param objectSchedule Objeto que contiene los valores mostrados en la pantalla.
     * @returns {Promise<unknown>}
     */
    saveAllSchedule(objectSchedule) {
        return axios.put('/appapv/saveAllSchedule.action', {}, {
            params: {
                horaI: objectSchedule.startOperationHr,
                minutosI: objectSchedule.startOperationMin,
                horaT: objectSchedule.endOperationHr,
                minutosT: objectSchedule.endOperationMin,
                horaIF: objectSchedule.startFormalizationHr,
                minutosIF: objectSchedule.startFormalizationMin,
                horaTF: objectSchedule.endFormalizationHr,
                minutosTF: objectSchedule.endFormalizationMin,
                horaPTM: objectSchedule.timeControlPanelPtmHr,
                minutosPTM: objectSchedule.timeControlPanelPtmMin,
                horaPTT: objectSchedule.timeControlPanelPttHr,
                minutosPTT: objectSchedule.timeControlPanelPttMin,
                horaFid: objectSchedule.timeControlPanelFidHr,
                minutosFid: objectSchedule.timeControlPanelFidMin,
                horaInd: objectSchedule.timeControlPanelIndevalHr,
                minutosInd: objectSchedule.timeControlPanelIndevalMin,
                horaLiq: objectSchedule.timeControlPanelLiqHr,
                minutosLiq: objectSchedule.timeControlPanelLiqMin,
                horaGSS: objectSchedule.timeControlPanelGSSHr,
                minutosGSS: objectSchedule.timeControlPanelGSSMin,
            }
        }).then(res => res.data);
    }

    /**
     * Función que borra un elemento de los horarios para instituciones
     * que se muestra en la pantalla de mantenimiento de horarios,
     * pestaña instituciones.
     * @param idInstitution Id de la institución de la que se borrará el horario.
     * @returns {Promise<unknown>}
     */
    deleteInstitutionSchedule(idInstitution) {
        return axios.delete('/appapv/deleteInstitutionSchedule.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idInstitucion: idInstitution,
            }
        }).then(res => {
            return res.data;
        });
    }

}